export const locales = {
  en: require('./en')
};

export default {
  logOut: '退出登录',
  language: '语言选择',
  modifyAdminPass: '修改管理密码',
  help: '帮助信息',
  hi: '你好，',
  logoutFailed: '登出失败',
  smartHardware: '智能硬件',
  hardwareManage: '硬件管理',
  enterpriseInternalApp: '企业内部应用',
  weCode: 'We码',
  liteApp: '轻应用',
  thirdPartyApp: '第三方企业应用',
  nointerface: '无界面应用',
  solutions: '解决方案',
  appMarket: '应用市场',
  subscribeStatistics: '订阅统计',
  weOpen: '开放平台',
  appDev: '应用开发',
  appConnect: '连接器',
  devDocs: '开发文档',
  searchHelp: '寻求帮助',
  roma: 'ROMA 插件',
  popularize: '应用推广',
  performanceTest: "性能测试工具",
  guidePage: "首页",
  applyCube: "Astro Zero",
  wecodeRadar: "We码雷达",
  wemax: "WeMax",
  developTools: "开发工具",
  weGo: "WeGo",
  connectors: "连接器",
  robot: "机器人"
};
